import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";

export class LongPressStore {
    longPressTriggered: boolean = false;

    rootStore: IRootStore;

    constructor(rootStore: IRootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    setLongPressTriggered = (isLongPress: boolean) => {
        this.longPressTriggered = isLongPress;
    }
    get getLongPressTrigger() {
        return this.longPressTriggered;
    }
}